<!-- <p>email works!</p> -->
<main class="main users chart-page" id="skip-target">
    <div class="container">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <h2 class="main-title">Compose Email</h2>
            <!-- <button type="button" class="primary-default-btn">Unod Changes</button>
            <button type="button" class="primary-default-btn">Close</button> -->
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
            <div class="col-12 ">
              <label class="form-label" for="name">Supplier</label>
            </div>
            <div class="col-12 ">
              <ng-select placeholder="select supplier" (change)="changesupplier($event)" [(ngModel)]="supplei_name">
                <ng-option *ngFor="let cl of mail_data" [value]="cl">
                  <span [title]="cl.sp_name">{{cl.sp_name}}</span>
                  </ng-option>
             </ng-select>
              <!-- <input type="text" formControlName="criticality" id="name"  placeholder="Name" required > -->
            </div>
          </div>
        
      <form>
        <div class="row form" style="padding-top: 10px;">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label class="form-label" for="name">To : </label>
                <input type="text" [(ngModel)]="mail_to" [ngModelOptions]="{standalone: true}" class="form-input" style="width: 100%;" />
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label class="form-label" for="name">Subject : </label>
                <input type="text" [(ngModel)]="mail_sub" [ngModelOptions]="{standalone: true}"  class="form-input" style="width: 100%;" />
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label class="form-label" for="Message">Message : </label>
                <div>
                    <jodit-editor [(ngModel)]="htm" [ngModelOptions]="{standalone: true}" (onChange)="handleEvent($event)"></jodit-editor>
                    <!-- <ckeditor
                        name="description" 
                        [editor]="editor">
                    </ckeditor> -->
                    <!-- <ckeditor name="myckeditor" debounce="300"></ckeditor> -->
                    <!-- <ejs-richtexteditor id='defaultRTE'>
                        <ng-template #valueTemplate>
                            <p>The Rich Text Editor component is WYSIWYG ("what you see is what you get") editor that provides the best user experience to create and update the content.
                            Users can format their content using standard toolbar commands.</p>
                            <p><b>Key features:</b></p>
                            <ul><li><p>Provides &lt;IFRAME&gt; and &lt;DIV&gt; modes.</p></li>
                            <li><p>Capable of handling markdown editing.</p></li>
                            <li><p>Contains a modular library to load the necessary functionality on demand.</p></li>
                            <li><p>Provides a fully customizable toolbar.</p></li>
                            <li><p>Provides HTML view to edit the source directly for developers.</p></li>
                            <li><p>Supports third-party library integration.</p></li>
                            <li><p>Allows preview of modified content before saving it.</p></li>
                            <li><p>Handles images, hyperlinks, video, hyperlinks, uploads, etc.</p></li>
                            <li><p>Contains undo/redo manager. </p></li>
                            <li><p>Creates bulleted and numbered lists.</p></li>
                            </ul>
                        </ng-template>
                    </ejs-richtexteditor> -->
                </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="border:1px solid gray;"></div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="float: right;padding-top: 10px;">
                <button type="button" style="background-color: #9e9e9e" class="primary-default-btn" style="float: right;" (click)="reset()">Cancel</button>
                <button type="button" class="primary-default-btn" style="float: right;margin-right: 10px !important;" (click)="sendmail()">Send</button>
            </div>
        </div>
      </form>
    </div>
</main>